import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { openCookiePrefs } from "@/lib/consent";

export const UPDATED = "22 ottobre 2026";

export const useCompany = () => {
  const [s, setS] = useState(null);
  useEffect(() => {
    api.get("/public/settings").then((r) => setS(r.data));
  }, []);
  return s;
};

export const companyLine = (s) => [s?.legal_name, s?.vat_number && `P.IVA ${s.vat_number}`, s?.address, s?.contact_email].filter(Boolean).join(" · ");

export const LegalLinks = ({ className = "", prefix = "legal" }) => (
  <span className={`inline-flex flex-wrap items-center justify-center gap-x-4 gap-y-1 ${className}`}>
    <Link to="/privacy" className="hover:underline" data-testid={`${prefix}-privacy-link`}>Privacy</Link>
    <Link to="/cookie" className="hover:underline" data-testid={`${prefix}-cookie-link`}>Cookie</Link>
    <button type="button" onClick={openCookiePrefs} className="hover:underline" data-testid={`${prefix}-cookie-prefs`}>Preferenze cookie</button>
  </span>
);

export const H = ({ children }) => <h2 className="mt-10 text-base font-semibold text-zinc-900 md:text-lg">{children}</h2>;

export const LegalLayout = ({ eyebrow, title, testId, children }) => (
  <div className="min-h-screen bg-[#FAFAF9] px-6 py-14">
    <article className="mx-auto max-w-2xl text-[15px] leading-relaxed text-zinc-700" data-testid={testId}>
      <Link to="/" className="text-sm text-zinc-500 hover:text-black" data-testid="legal-home-link">← SALVILO</Link>
      <div className="eyebrow mt-8">{eyebrow}</div>
      <h1 className="mt-2 font-display text-4xl text-zinc-900 sm:text-5xl">{title}</h1>
      <div className="mt-2 text-xs text-zinc-500">Ultimo aggiornamento: {UPDATED}</div>
      {children}
      <div className="mt-14 border-t pt-6 text-xs text-zinc-500"><LegalLinks prefix="legal-page" /></div>
    </article>
  </div>
);
